/** Страницата с профила на влезлия потребител. */
export default {
  signInRequired: {
    title: "Необходим е вход",
    body: "Моля, влезте, за да видите профила, точките и поръчките си.",
  },
  planNames: {
    free: "Безплатен",
    starter: "Starter",
    pro: "Pro",
    elite: "Elite",
    studio: "Studio",
  },
  planBadge: "План {{plan}}",
  yourName: "Вашето име",
  upgradePlan: "Купете точки",
  startGenerating: "Започнете генериране",
  details: {
    title: "Данни на профила",
    fullName: "Име и фамилия",
    fullNamePlaceholder: "Вашето име",
    saving: "Запазване…",
    save: "Запазете промените",
    updated: "Профилът е обновен",
    saveFailed: "Профилът не можа да бъде запазен",
  },
  stats: {
    credits: "Точки за генериране",
    buyMore: "Купете още точки",
    memberSince: "Член от",
  },
  plans: {
    eyebrow: "Планове",
    title: "Изберете своя план",
    subtitle: "Купете нов пакет точки, когато имате нужда от още. Всеки пакет е еднократно плащане – нищо не се подновява автоматично.",
    mostPopular: "Най-популярен",
  },
};
